@if (list$ | async; as list) { @switch (true) { @case (isCommercialList(list)) {
<epc-shop-the-commercial-list
  [list]="list"
  class="flex-grow-1 flex-mg-grow-auto"
>
</epc-shop-the-commercial-list>
}
<!-- Regular list call to action button -->
@default {
<button
  [disabled]="shopTheListDisabled$ | async"
  class="btn btn-primary d-inline-flex align-items-center justify-content-center flex-grow-1 flex-mg-grow-auto shop-the-list-button ml-md-2"
  (click)="shopTheList()"
  data-e2e="shop-the-list"
>
  @if (shopListLoading$ | async) {
  {{ shopTheListLoadingText }}
  } @else {
  {{ buttonText }}
  <span class="arrows-animation">
    <fa-icon [icon]="['fas', 'angle-right']" class="ml-2"></fa-icon>
    <fa-icon [icon]="['fas', 'angle-right']"></fa-icon>
    <fa-icon [icon]="['fas', 'angle-right']"></fa-icon>
  </span>
  }
</button>
} } }
